import { render, staticRenderFns } from "./ManageContainerBenefits.modal.vue?vue&type=template&id=1912346a"
import script from "./ManageContainerBenefits.modal.vue?vue&type=script&lang=js"
export * from "./ManageContainerBenefits.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports